import BaseComponent from "../core/base-component";
import type { PhotoSwipeOptions, SlideData } from 'photoswipe';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeLightbox from 'photoswipe/lightbox';

const defaultPhotoswipeOptions: PhotoSwipeOptions = {
    pswpModule: PhotoSwipe,
    loop: true,
    bgOpacity: 0.8,
    zoom: true,
    wheelToZoom: false,
    closeTitle: 'schließen',
    zoomTitle: 'vergrößern',
    arrowPrevTitle: 'zurück',
    arrowNextTitle: 'weiter',
    errorMsg: 'Das Foto konnte aufgrund eines Fehlers nicht geladen werden',
    indexIndicatorSep: ' / ',
    preloadFirstSlide: true
};

const DEFAULT_ELEMENT_SELECTOR = 'button[rel="fullsize"],a[rel="fullsize"]';

const galleryInstanceMap = new Map<HTMLElement, SlideData[]>();

class Lightbox extends BaseComponent {
    protected options: PhotoSwipeOptions = defaultPhotoswipeOptions;

    public override init() {
        this.options = this.assignConfig<PhotoSwipeOptions>(defaultPhotoswipeOptions, this.config, undefined, true);

        this.options.closeTitle = window.ThiemeCore.Lang.translate('closeTitle', null, this.options.closeTitle, 'photoswipe');
        this.options.zoomTitle = window.ThiemeCore.Lang.translate('zoomTitle', null, this.options.zoomTitle, 'photoswipe');
        this.options.arrowPrevTitle = window.ThiemeCore.Lang.translate('arrowPrevTitle', null, this.options.arrowPrevTitle, 'photoswipe');
        this.options.arrowNextTitle = window.ThiemeCore.Lang.translate('arrowNextTitle', null, this.options.arrowNextTitle, 'photoswipe');
        this.options.indexIndicatorSep = window.ThiemeCore.Lang.translate('indexIndicatorSep', null, this.options.indexIndicatorSep, 'photoswipe');
        this.options.errorMsg = window.ThiemeCore.Lang.translate('errorMsg', null, this.options.errorMsg, 'photoswipe');
    }
    public override process() {
        let dataSource: SlideData[] = [];

        let caption: string  = this.element.dataset.caption ?? this.element.closest<HTMLElement>('figure')?.querySelector<HTMLElement>('figcaption')?.textContent ?? '';

        if(this.element.dataset.gallery && this.element.dataset.gallery != '') {
            const galleryEl = document.querySelector<HTMLElement>('#'+this.element.dataset.gallery);
            if(galleryEl) {
                if(galleryInstanceMap.has(galleryEl)) {
                    dataSource = galleryInstanceMap.get(galleryEl) as SlideData[];
                } else {
                    galleryEl.querySelectorAll<HTMLElement>(DEFAULT_ELEMENT_SELECTOR).forEach((el: HTMLElement, idx: number) => {
                        let caption: string  = el.dataset.caption ?? el.closest<HTMLElement>('figure')?.querySelector<HTMLElement>('figcaption')?.textContent ?? '';
                        dataSource.push({
                            src: el.getAttribute('href') ?? '',
                            caption: caption,
                            width: 0,
                            height: 0,
                            srcset: '',
                            alt: '',
                            thumb: el.parentNode?.querySelector('img')?.getAttribute('src') ?? '',
                            el: el
                        });
                    });
                }
                galleryInstanceMap.set(galleryEl, dataSource);
            } else {
                dataSource.push({
                    src: this.element.getAttribute('href') ?? '',
                    caption: caption,
                    width: 0,
                    height: 0,
                    srcset: '',
                    alt: '',
                    thumb: this.element.parentNode?.querySelector('img')?.getAttribute('src') ?? '',
                    el: this.element
                });
            }
        } else {
            dataSource.push({
                src: this.element.getAttribute('href') ?? '',
                caption: caption,
                width: 0,
                height: 0,
                srcset: '',
                alt: '',
                thumb: this.element.parentNode?.querySelector('img')?.getAttribute('src') ?? '',
                el: this.element
            });
        }

        let currentElementIndex = 0;
        dataSource.forEach((item: SlideData, idx: number) => {
            if(item.el == this.element) {
                currentElementIndex = idx;
                return false;
            }
        });


        const options: PhotoSwipeOptions = this.options;
        options.dataSource = dataSource;

        const lightboxInstance = new PhotoSwipeLightbox(options);

        lightboxInstance.on('contentLoadImage', (ev: any) => {
            if(ev.content.element) {
                ev.content.element.style.width = '';
                ev.content.element.style.height = '';
            }
        });
        lightboxInstance.on('uiRegister', () => {
            if(typeof(lightboxInstance.pswp) == 'undefined') {
                return;
            }

            lightboxInstance.pswp.ui?.registerElement({
                name: 'custom-caption',
                order: 9,
                isButton: false,
                appendTo: 'root',
                html: 'Caption text',
                onInit: function(captionElement: HTMLElement, pswp: PhotoSwipe) {
                    captionElement.style.display = 'none';
                    lightboxInstance.pswp?.on('change', function() {
                        if(lightboxInstance.pswp?.currSlide?.data.caption && lightboxInstance.pswp?.currSlide?.data.caption != '') {
                            captionElement.innerHTML = '<div class="caption text-center">'+lightboxInstance.pswp.currSlide.data.caption+'</div>';
                            captionElement.style.display = 'block';
                        } else {
                            captionElement.innerHTML = '';
                            captionElement.style.display = 'none';
                        }
                    });
                }
            });
        });
        lightboxInstance.init();

        this.element.addEventListener('click', (ev: MouseEvent) => {
            lightboxInstance.loadAndOpen(currentElementIndex);
        });
    }
}

// Observe
Lightbox.initializeDom(DEFAULT_ELEMENT_SELECTOR, false, true, true);

export default Lightbox;
